<template>
  <div>
    <ChallengeEditor
      :challenge="challenge"
      title="チャレンジ新規作成"
      save-label="保存"
      @save="save($event)"
    />

    <v-snackbar
      color="success"
      v-model="saved"
      :timeout="4000"
    >
      プロフィールを更新しました
    </v-snackbar>

    <v-snackbar
      color="error"
      v-model="failed"
      :timeout="6000"
    >
      エラー：{{ failed_message }}
    </v-snackbar>
  </div>
</template>

<script>
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"

import ChallengeEditor from '@/components/ChallengeEditor.vue'

export default {
  components: {
    ChallengeEditor,
  },
  data: () => ({
    challenge: {
      name: "",
      description: "",
      expireAtText: new Date(Date.now()+1000*60*60*24*14).toISOString().substr(0, 10),
      publish: false,
      regulation: {
        clockPeriod: "2",
        csimTimeout: "5",
        hlsTimeout: "15",
        cosimTimeout: "15",
        synTimeout: "30",
        max_ff: "-1",
        max_lut: "-1",
        max_dsp: "-1",
        max_bram: "-1",
        max_uram: "-1",
        tool_ver: "2022.1",
        cxxflags: "",
        ldflags: "",
      },
      files: {
        readme: "# 問題\n\n",
        kernel_header: "#pragma once\n\nextern \"C\" {\nvoid kernel();\n}",
        kernel_source: "",
        public_tb: "",
        private_tb: "",
      }
    },
    saved: false,
    failed: false,
    failed_message: "",
    public_file_keys: ["readme", "kernel_header", "kernel_source", "public_tb"],
    private_file_keys: ["private_tb"],
  }),
  methods: {
    async save(challenge) {
      try {
        //console.log("Save challenge", challenge)
        const uid = this.$store.state.user.uid
        const userRef = db.collection("users").doc(uid)

        const challengeDat = Object.assign({}, challenge)
        challengeDat.user = uid
        challengeDat.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
  
        const cnameRef = db.collection("challengenames").doc(challenge.name)
  
        // Check challenge name exists
        await db.runTransaction(async tx => {
          const cnameDoc = await tx.get(cnameRef)
          if (cnameDoc.exists) {
            throw new Error('このチャレンジ名は使用されています')
          }
          tx.set(cnameRef, {})
        })
  
        // Save files
        const public_files = { private: false, editable: true }
        const private_files = { private: true, editable: true }
        for (const key of this.public_file_keys) {
          public_files[key] = this.challenge.files[key]
        }
        for (const key of this.private_file_keys) {
          private_files[key] = this.challenge.files[key]
        }
        challengeDat.public_files = (await userRef.collection("files").add(public_files)).path
        challengeDat.private_files = (await userRef.collection("files").add(private_files)).path

        // Delete temporary files object
        delete challengeDat.files
        delete challengeDat.expireAtText
  
        const challengeRef = await userRef.collection("challenges").add(challengeDat)
        await cnameRef.set({ challenge: challengeRef.id, user: userRef.id })

        this.$router.replace('/challenge/' + challengeDat.name)
      } catch (e) {
        this.failed_message = e.message
        this.failed = true
      }
    },
  },
}
</script>

